module.exports = __webpack_public_path__ + "static/media/savant-cu-white.b1ca6e15.svg";